import React from "react";

const MonthEndClosingChecklist = () => {
  const summary = {
    total: 9,
    completed: 3,
    pending: 6,
    mandatoryCompleted: 3,
    mandatoryTotal: 8,
  };

  const tasks = [
    {
      title: "Bank-Reconciliation",
      assignee: "John Doe",
      date: "2025-01-31",
      mandatory: true,
      status: "completed",
    },
    {
      title: "Job-Closing",
      assignee: "Jane Smith",
      date: "2025-01-31",
      mandatory: true,
      status: "completed",
    },
    {
      title: "TDS Calculation",
      assignee: "Mike Anderson",
      date: "2025-01-31",
      mandatory: true,
      status: "pending",
    },
    {
      title: "GST Return Preparation",
      assignee: "Sarah Williams",
      date: "2025-01-31",
      mandatory: false,
      status: "pending",
    },
    {
      title: "Inventory Valuation",
      assignee: "John Doe",
      date: "2025-01-31",
      mandatory: true,
      status: "completed",
    },
    {
      title: "Provision Calculations",
      assignee: "Mike Anderson",
      date: "2025-01-31",
      mandatory: false,
      status: "pending",
    },
    {
      title: "Trial Balance Review",
      assignee: "Sarah Williams",
      date: "2025-01-31",
      mandatory: false,
      status: "pending",
    },
    {
      title: "P&L Analysis",
      assignee: "Sarah Williams",
      date: "2025-01-31",
      mandatory: true,
      status: "pending",
    },
  ];

  const progress = (summary.completed / summary.total) * 100;

  return (
    <div className="container py-4">
      {/* SUMMARY CARDS */}
      <div className="row g-3">
        <div className="col-12 col-md-3 col-sm-6">
          <div className="card p-3 rounded-4 shadow-sm">
            <p className="text-muted mb-1">Total Tasks</p>
            <h3 className="fw-semibold">{summary.total}</h3>
          </div>
        </div>

        <div className="col-12 col-md-3 col-sm-6">
          <div className="card p-3 rounded-4 shadow-sm">
            <p className="text-muted mb-1">Completed</p>
            <h3 className="text-success fw-semibold">{summary.completed}</h3>
          </div>
        </div>

        <div className="col-12 col-md-3 col-sm-6">
          <div className="card p-3 rounded-4 shadow-sm">
            <p className="text-muted mb-1">Pending</p>
            <h3 className="text-warning fw-semibold">{summary.pending}</h3>
          </div>
        </div>

        <div className="col-12 col-md-3 col-sm-6">
          <div className="card p-3 rounded-4 shadow-sm">
            <p className="text-muted mb-1">Mandatory Tasks</p>
            <h3 className="text-primary fw-semibold">
              {summary.mandatoryCompleted}/{summary.mandatoryTotal}
            </h3>
          </div>
        </div>
      </div>

      {/* PROGRESS BAR */}
      <div className="mt-4">
        <h6 className="fw-semibold mb-2">Overall Progress</h6>

        <div className="progress" style={{ height: "8px" }}>
          <div
            className="progress-bar bg-dark"
            style={{ width: `${progress}%` }}
          ></div>
        </div>

        <small className="text-muted">
          Completion Status: {progress.toFixed(1)}%
        </small>
      </div>

      {/* HEADER WITH BUTTONS */}
      <div className="d-flex justify-content-between align-items-center mt-5">
        <h5 className="fw-semibold">
          Month-End Closing Checklist – January 2025
        </h5>

        <div className="d-flex gap-2">
          <button className="btn btn-primary px-4">
            <i className="fas fa-plus me-1"></i> Add Task
          </button>

          <button className="btn btn-light border px-4">
            <i className="fas fa-file me-1"></i> Generate Report
          </button>

          <button className="btn btn-light border px-4">
            <i className="fas fa-file-export me-1"></i> Export Checklist
          </button>
        </div>
      </div>

      <div className="mt-3">
        {tasks.map((task, index) => (
          <div
            key={index}
            className="card p-3 mb-2 rounded-4 border border-light-subtle"
          >
            <div className="d-flex justify-content-between align-items-start">
              {/* LEFT */}
              <div className="d-flex">
                {/* Checkbox */}
                <input type="checkbox" className="form-check-input me-3 mt-1" />

                <div>
                  {/* Title + Mandatory */}
                  <h6 className="fw-semibold mb-1 d-flex align-items-center gap-2">
                    {task.title}

                    {task.mandatory && (
                      <span className="badge bg-light text-dark border">
                        Mandatory
                      </span>
                    )}
                  </h6>

                  {/* Assignee */}
                  <div className="d-flex">
                    <p className="text-muted mb-0 me-2">Assignee: {task.assignee}</p>
                    <p className="text-muted mb-1">Due: {task.date}</p>
                  </div>
                </div>
              </div>

              {/* RIGHT */}
              <div className="text-end">
                {/* Status Circle (Bootstrap only) */}
                {task.status === "pending" ? (
                  <div
                    className="rounded-circle border border-warning text-warning d-flex align-items-center justify-content-center"
                    style={{ width: "26px", height: "26px" }}
                  >
                    !
                  </div>
                ) : (
                  <div
                    className="rounded-circle bg-success d-flex align-items-center justify-content-center text-white"
                    style={{ width: "26px", height: "26px" }}
                  >
                    ✓
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MonthEndClosingChecklist;
